export enum APPLICATION_STATUS_ID {
  STATUS_NEW = 1,
  STATUS_IN_PROGRESS = 2,
  STATUS_ISSUED = 3,
  STATUS_REJECTED = 4,
  STATUS_AWAITING_ISSUANCE = 5,
  STATUS_DRAFT = 6,
  STATUS_UNDER_REVISION = 7,
  STATUS_PROPOSAL = 8,
  STATUS_CLIENT_REJECTED = 9,
  STATUS_SIGNATURE_REQUIRED = 10,
  STATUS_PAYMENT_REQUIRED = 11,
  STATUS_UNDER_REVIEW = 12,
  STATUS_RETURNED_FOR_REVISION = 13,
  STATUS_RELEASED = 14,
};
